import { useContext } from 'react';
import clsx from 'clsx';

import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';

import WorkTemplateDetails from './WorkTemplateDetails';
import WorkTemplateFields from './WorkTemplateFields';
import WorkTemplateMap from './WorkTemplateMap';
import WorkTemplateSummary from './WorkTemplateSummary';

import classes from './workTemplateInfo.module.css';

const WorkTemplateInfo = () => {
  const { workTemplate } = useContext(WorkTemplateContext);

  return (
    <div className={classes.infoContainer}>
      {workTemplate?.schemaId ? (
        <>
          <div className={clsx(classes.pane, classes.left)}>
            <WorkTemplateSummary />
            <WorkTemplateFields />
            <WorkTemplateDetails />
          </div>
          <div className={classes.pane}>
            <WorkTemplateMap />
          </div>
        </>
      ) : (
        <div className={classes.noLocationPane}>
          <WorkTemplateSummary />
          <WorkTemplateFields />
          <WorkTemplateDetails />
        </div>
      )}
    </div>
  );
};

export default WorkTemplateInfo;
